/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { TNO_BUSINESS_PATROCINIO_PATH } from '../brandAssets';

const InstitutionalFooter = () => {
  return (
    <Box mt={8} mb={4} textAlign="center">
      <Typography
        variant="subtitle1"
        component="p"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        TNO Business: Donde la evolución de los negocios comienza con una conexión.
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        <Link component={RouterLink} to={TNO_BUSINESS_PATROCINIO_PATH} color="primary" underline="hover">
          Media kit de patrocinio TNO Business
        </Link>
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        © TNO Business 2026 | The Content Evolution.
      </Typography>
    </Box>
  );
};

export default InstitutionalFooter;

